module.exports = __webpack_public_path__ + "onboarding-spaces.91401ef3978e56b94fdc8375273e3289.hashedasset.svg";